import { useContext } from "react";
import { GameContext } from "../../../../../contexts/GameContext";

interface Props {
    parameter: "temp" | "window" | "curtains" | "mecanical_ventilation" | "artificial_light" | "electric_equipement" |
    "dressing" | "cost" | "ges" | "air_quality" | "visual_comfort" | "thermal_comfort" | "chauffage" | "climatisation" | "electricity"
}


const DetailsPopup = ({ parameter }: Props) => {
    const { interfaceParams } = useContext(GameContext);

    return (
        <div>
            {interfaceParams ? <div style={{display:"flex", flexDirection:"column", padding:"0 0 1rem 0"}}>
                {interfaceParams.definitions[parameter].map((paragraph, idx) => 
                    <p key={idx}>{paragraph}</p>
                )}
                {parameter=="dressing" && 
                    <img src="/img/clo/clo.png" alt="" style={{margin:"0 auto"}} />
                }
            </div> : null}
        </div>
    );
};


export default DetailsPopup;